import React, {Component} from 'react';
import Footer from "../../components/Footer/index";

class FooterView extends Component {
    render() {
        return (
            <Footer/>
        );
    }
}

export default FooterView;


// WEBPACK FOOTER //
// ./src/views/Footer/index.js